const AppId = '7ad75dc9-2169-4e8c-91bd-8ba1ef739b10';
const AdminServer = 'https://ns-admin.win.eventizer.hk'; // dev
// const AdminServer = 'https://admin.uat.intimex.hk'; // uat
// const AdminServer = 'https://admin.uat.in-store.hk'; // Production
module.exports = {
  // instore app id admin的id
  AppId: AppId,
  // api server url 統一配置Api服務器的url
  // ApiServer: 'https://api.uat.in-store.hk', // Production
  // ApiServer: 'https://api.uat.intimex.hk', // uat
  ApiServer: 'https://ns-api.win.eventizer.hk', // dev
  // api version for this app 統一配置Api版本號
  ApiVersion: 'V2',
  // api Authorization 身份认证，用于后端识别客户端
  Authorization: 'N2FkNzVkYzktMjE2OS00ZThjLTkxYmQtOGJhMWVmNzM5YjEwOjU1NzE5ZmI2LWQ4ZDktNDlhZS1hZjZhLTY1MjVkMjFkYTY2MA==',
  // admin server url, for login management platform 統一配置admin服務器

  AdminServer: AdminServer,
  // url '/admin' auto open admin tab
  AutoOpenAdmin: true,
  // admin login url 統一配置admin登錄地址
  AdminLoginUrl: AdminServer + '/default/ClientLogin/' + AppId,
  // 前端默认配置
  FrontE: {
    defaultLang: 'C',
    mobileBuilding: false,
    pcBuilding: false,
    cmsSeoList: ['20299', '20300', '20301', '20302', '20303', '20304', '20305'],
    productSeoList: ['Home']
  }
};
